/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import noImage from 'src/assets/images/no-image.jpeg';
import { DEFAULT_CONFIGS } from 'src/constants';
import useSearchQueryParams from 'src/hooks/useSearchQueryParams';
import '../index.scss';
import useTranslate from 'src/hooks/useTranslate';
import useSort from 'src/hooks/useSort';
import { usePreventTranslate } from 'src/hooks/usePreventTranslate';
import { isFun } from 'src/conponents/Shared/Header';

const onError = (e) => {
  e.target.src = noImage;
};

function AllGames({ games }) {
  const translate = useTranslate();
  const { sortBy } = useSort();
  const brandCode = useSearchQueryParams('oc', DEFAULT_CONFIGS.brandCode);
  const playerToken = useSearchQueryParams('t', DEFAULT_CONFIGS.playerToken);
  const l = useSearchQueryParams('l', 'en');
  const [childWindow, setChildWindow] = useState(null);

  const handleOnClick = (e) => {
    const { url } = e.target.dataset;

    if (url) {
      const playUrl = new URL(url);
      playUrl.searchParams.append('oc', brandCode);
      if (isFun) {
        playUrl.searchParams.append('isFun', 'true');
      } else {
        playUrl.searchParams.append('t', playerToken);
      }
      playUrl.searchParams.append(
        'l',
        brandCode === 'ngdemo' ? 'tzh' : l || 'en',
      );
      playUrl.searchParams.append('r', window.location.toString());
      const newWindow = window.open(playUrl, '_blank');
      setChildWindow(newWindow);
    }
  };

  useEffect(() => {
    const handleMessage = (event) => {
      if (event && event.data?.action === 'CLOSE') {
        if (childWindow) {
          childWindow.close();
        }
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [childWindow]);

  return (
    <div className="lobby-card-wrapper">
      {games?.length > 0 &&
        games.map((item) => (
          <div key={item.code}>
            <div className="lobby-card-container position-relative">
              <div className="lobby-card-label-container">
                {(sortBy === 'maxWin' || sortBy === 'rtp') && (
                  <div className="left">
                    <Tag type={sortBy} shouldPreventTranslate>
                      {item[sortBy] || '-'}
                      {item[sortBy] > 0 &&
                        ((sortBy === 'maxWin' &&
                          (item.type === 'CASUAL' ? '' : '×')) ||
                          (sortBy === 'rtp' && '%'))}
                    </Tag>
                  </div>
                )}

                {Boolean(item.isPopular || item.isNew) && (
                  <div className="right">
                    {Boolean(item.isNew) && <Tag type="new">New</Tag>}
                    {Boolean(item.isPopular) && <Tag type="hot">Hot</Tag>}
                  </div>
                )}
              </div>
              <Card>
                <div className="img-ratio-wrapper">
                  <Card.Img
                    variant="top"
                    src={item.preview || noImage}
                    onError={onError}
                    loading="lazy"
                    className="img-ratio-img"
                  />
                </div>
                <Card.Body>
                  <Card.Title>
                    {/* <span className="title">{item.name}</span> */}
                    <span className="online">
                      {(item.playerOnline && `${item.playerOnline} online`) ||
                        ''}
                    </span>
                  </Card.Title>
                  <Card.Text>{item.desc}</Card.Text>
                  <Card.Subtitle className="info-container">
                    <span className="info">
                      <span>
                        {(item.maxWin &&
                          `${item.maxWin}${
                            item.type === 'CASUAL' ? '' : '×'
                          }`) ||
                          '-'}
                      </span>
                      <span>Max Win</span>
                    </span>
                    <span className="info text-center">
                      <span>{item.volatility || '-'}</span>
                      <span>Volatility</span>
                    </span>
                    <span className="info text-end">
                      <span>{(item.rtp && `${item.rtp}%`) || '-'}</span>
                      <span>RTP</span>
                    </span>
                  </Card.Subtitle>
                  <Button
                    variant="danger"
                    data-url={item.url}
                    onClick={handleOnClick}
                  >
                    {translate('common.text.playNow', 'Play Now')}
                  </Button>
                </Card.Body>
              </Card>
            </div>
          </div>
        ))}
    </div>
  );
}

AllGames.propTypes = {
  games: PropTypes.array,
};

function Tag({ type, children, shouldPreventTranslate = false }) {
  const { replaced, content } = usePreventTranslate(children);

  if (replaced) shouldPreventTranslate = true;

  return (
    <div
      className={`lobby-card-label ${type}-label ${
        shouldPreventTranslate ? 'notranslate' : ''
      }`}
    >
      {content}
    </div>
  );
}

export default AllGames;
